import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';
import { SCEventCall } from 'static/classes/Event';

export function EventCallsViewModel(data) {

    var self = this;
    self.type = "EventCallsViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = function(){

        console.log('initing all event details vm');

        if (!self.initialized()){
          self.lookup_event_calls().then(function(){
                console.log('done looking up event_calls');

          })};
    }

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable(0);
    self.limit = ko.observable(20);

    self.selected_call_status = ko.observable();
    self.search_name = ko.observable();

    self.only_bypass = ko.observable(false);
    self.only_confirms = ko.observable(false);

    self.search_name_click = function(){
        self.offset(0);
        console.log('searching with ', self.search_name());
        self.lookup_event_calls();
        return false;
    }

    self.event_calls = ko.observableArray([]);

    self.error = ko.observable();
    self.event_uuid_search = ko.observable();

    self.set_selected_data = function(scevent, tabId){
        setDataAndShowDetailsModal(scevent, tabId);
    };

    self.lookup_event_calls = function(){
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/event-calls',
            type: 'GET',
            data:{
                limit: self.limit(),
                offset: self.offset(),
                selected_call_status: self.selected_call_status(),
                only_bypass: self.only_bypass(),
                only_confirms: self.only_confirms()
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {

                self.event_calls(ko.utils.arrayMap( data.event_calls || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new SCEventCall(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);
            },

            error: function (data) {
                self.error(data.statusText);
            }
        });
    };

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_event_calls();

    };

    self.go_right = function () {
        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_event_calls();
    };


    // For an individual call mark as 'not bypass attempt'
    self.mark_not_bypass = async (event_call) =>{
        const answer = confirm("Confirm that you'd like to mark this as safe (no bypass)");

        if (answer == true){
            const url = scvm.web_host + '/api/admin/event-call/mark-no-bypass';
            const request = new Request(url, {
                body: JSON.stringify({
                    call_uuid: event_call.event_call_uuid
                }),
                processData: false,
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json; charset=utf-8'
                })
            });

            const response = await fetch(request);
            const data = await response.json();
            if (data.success) {
                event_call.possible_bypass_attempt(false);
                notyf.success("Marked as safe");

            } else {
                console.error(data.message);
                notyf.error(data.statusText);
                throw new Error(data.message)
            }


        }
    }

};
